import React from "react";
import styles from "../styles/parking.module.css";
import paymentGatewayImage from "../assets/insure.jpg";
import { Link } from "react-router-dom";

import Header from "../components/Header";
// import pic from "../assets/park.png";
import view from "../assets/insure2.jpg";
// import park from "../assets/park.png";
import Footer from "../components/Footer";

const CarParking = () => {
  const RecurringPaymentsIcon = () => (
    <svg
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.5632 38.625H20.2507C16.4001 38.625 14.4768 38.625 13.2804 37.4286C12.084 36.2322 12.084 34.3089 12.084 30.4583V22.2917C12.084 18.4411 12.084 16.5178 13.2804 15.3214C14.4768 14.125 16.4001 14.125 20.2507 14.125H44.7507C48.6012 14.125 50.5245 14.125 51.7209 15.3214C52.9173 16.5178 52.9173 18.4411 52.9173 22.2917V32.5C52.9173 34.4028 52.9173 35.3543 52.607 36.1035C52.4018 36.5993 52.1009 37.0497 51.7215 37.4291C51.3421 37.8085 50.8916 38.1095 50.3959 38.3147C49.6466 38.625 48.6952 38.625 46.7923 38.625"
        stroke="#A6DC94"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.5417 42.7087C34.5417 41.0842 35.187 39.5263 36.3356 38.3776C37.4843 37.229 39.0422 36.5837 40.6667 36.5837V32.5003C40.6667 30.8759 41.312 29.318 42.4606 28.1693C43.6093 27.0206 45.1672 26.3753 46.7917 26.3753V37.6045C46.7917 42.3718 46.7917 44.7544 45.828 46.5592C45.0666 47.9836 43.9 49.1503 42.4756 49.9117C40.6708 50.8753 38.2881 50.8753 33.5208 50.8753H32.5C28.6943 50.8753 26.7915 50.8753 25.2929 50.2526C24.3018 49.8427 23.4011 49.2415 22.6423 48.4834C21.8836 47.7253 21.2815 46.8252 20.8707 45.8345C20.25 44.3338 20.25 42.431 20.25 38.6253M36.5833 26.3753C36.5833 27.4583 36.1531 28.4969 35.3874 29.2627C34.6216 30.0285 33.583 30.4587 32.5 30.4587C31.417 30.4587 30.3784 30.0285 29.6126 29.2627C28.8469 28.4969 28.4167 27.4583 28.4167 26.3753C28.4167 25.2924 28.8469 24.2537 29.6126 23.488C30.3784 22.7222 31.417 22.292 32.5 22.292C33.583 22.292 34.6216 22.7222 35.3874 23.488C36.1531 24.2537 36.5833 25.2924 36.5833 26.3753Z"
        stroke="#A6DC94"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const BulkPaymentsIcon = () => (
    <svg
      width="66"
      height="65"
      viewBox="0 0 66 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.4975 46.9644V53.393M40.5332 43.7501V50.1787M24.4618 43.7501V50.1787M35.9175 20.8934C35.7344 20.3698 35.3927 19.9163 34.9399 19.596C34.4871 19.2757 33.9457 19.1045 33.3911 19.1062H31.3178C30.7299 19.1083 30.1633 19.3269 29.7263 19.7203C29.2893 20.1137 29.0126 20.6543 28.949 21.2389C28.8853 21.8234 29.0393 22.4109 29.3814 22.8891C29.7235 23.3673 30.2298 23.7027 30.8036 23.8312L33.9632 24.5255C34.6066 24.669 35.1745 25.0445 35.5586 25.5802C35.9426 26.116 36.1158 26.7744 36.045 27.4298C35.9742 28.0852 35.6644 28.6915 35.1748 29.1329C34.6853 29.5743 34.0502 29.8199 33.3911 29.8226H31.6039C31.0493 29.8243 30.5079 29.6531 30.0551 29.3328C29.6023 29.0125 29.2606 28.559 29.0775 28.0355M32.4975 19.1062V16.4287M32.4975 32.5001V29.8226M18.8368 25.268C18.6237 25.268 18.4193 25.1833 18.2686 25.0326C18.1179 24.8819 18.0332 24.6775 18.0332 24.4644C18.0332 24.2513 18.1179 24.0469 18.2686 23.8962C18.4193 23.7455 18.6237 23.6609 18.8368 23.6609C19.0499 23.6609 19.2543 23.7455 19.405 23.8962C19.5557 24.0469 19.6403 24.2513 19.6403 24.4644C19.6403 24.6775 19.5557 24.8819 19.405 25.0326C19.2543 25.1833 19.0499 25.268 18.8368 25.268ZM46.1582 25.268C45.9451 25.268 45.7407 25.1833 45.59 25.0326C45.4393 24.8819 45.3546 24.6775 45.3546 24.4644C45.3546 24.2513 45.4393 24.0469 45.59 23.8962C45.7407 23.7455 45.9451 23.6609 46.1582 23.6609C46.3713 23.6609 46.5757 23.7455 46.7264 23.8962C46.8771 24.0469 46.9618 24.2513 46.9618 24.4644C46.9618 24.6775 46.8771 24.8819 46.7264 25.0326C46.5757 25.1833 46.3713 25.268 46.1582 25.268Z"
        stroke="#A6DC94"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.1769 11.6074H14.8198C13.9673 11.6074 13.1497 11.9461 12.5469 12.5489C11.9441 13.1517 11.6055 13.9692 11.6055 14.8217V34.1074C11.6055 34.9599 11.9441 35.7775 12.5469 36.3803C13.1497 36.9831 13.9673 37.3217 14.8198 37.3217H50.1769C51.0294 37.3217 51.8469 36.9831 52.4497 36.3803C53.0525 35.7775 53.3912 34.9599 53.3912 34.1074V14.8217C53.3912 13.9692 53.0525 13.1517 52.4497 12.5489C51.8469 11.9461 51.0294 11.6074 50.1769 11.6074Z"
        stroke="#A6DC94"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const SplitPaymentsIcon = () => (
    <svg
      width="66"
      height="65"
      viewBox="0 0 66 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.127 19.375V23.125M39.127 30.625V34.375M39.127 41.875V45.625M20.377 19.375H46.627C47.6215 19.375 48.5753 19.7701 49.2786 20.4733C49.9819 21.1766 50.377 22.1304 50.377 23.125V28.75C49.3824 28.75 48.4286 29.1451 47.7253 29.8484C47.022 30.5516 46.627 31.5054 46.627 32.5C46.627 33.4946 47.022 34.4484 47.7253 35.1516C48.4286 35.8549 49.3824 36.25 50.377 36.25V41.875C50.377 42.8696 49.9819 43.8234 49.2786 44.5266C48.5753 45.2299 47.6215 45.625 46.627 45.625H20.377C19.3824 45.625 18.4286 45.2299 17.7253 44.5266C17.022 43.8234 16.627 42.8696 16.627 41.875V36.25C17.6215 36.25 18.5753 35.8549 19.2786 35.1516C19.9819 34.4484 20.377 33.4946 20.377 32.5C20.377 31.5054 19.9819 30.5516 19.2786 29.8484C18.5753 29.1451 17.6215 28.75 16.627 28.75V23.125C16.627 22.1304 17.022 21.1766 17.7253 20.4733C18.4286 19.7701 19.3824 19.375 20.377 19.375Z"
        stroke="#A6DC94"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const EventPaymentIntegrationIcon = () => (
    <svg
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.7739 47.5395C26.9984 48.2445 26.1974 49.114 25.8704 49.159C25.5434 49.2041 25.2026 48.9945 24.4721 48.5813L20.7474 46.482C19.8074 46.012 19.7604 45.6595 19.7604 45.542C19.7604 45.4245 19.7604 44.9271 20.0659 43.9048C21.0451 40.137 18.7499 36.142 14.8509 35.1237C13.8286 34.8495 13.3175 34.7104 13.1158 34.4461C12.9141 34.1817 12.9141 33.7607 12.9141 32.9107V29.1449C12.9141 28.2969 12.9141 27.8719 13.1158 27.6095C13.3175 27.3452 13.8286 27.2081 14.8509 26.9319C18.6696 25.9019 21.0627 22.0204 20.0796 18.2272C19.8054 17.1834 19.6723 16.6605 19.8015 16.355C19.9308 16.0495 20.3009 15.838 21.0451 15.415L24.4232 13.4978C25.1517 13.0865 25.5159 12.877 25.843 12.922C26.17 12.9651 26.5382 13.3333 27.2765 14.0716C30.1356 16.9209 34.8631 16.9209 37.7203 14.0716C38.4586 13.3352 38.8287 12.9671 39.1557 12.922C39.4828 12.8789 39.847 13.0846 40.5755 13.4997L43.9536 15.4169C44.6978 15.838 45.0679 16.0495 45.1972 16.3569C45.3264 16.6605 45.1913 17.1834 44.9191 18.2272C43.9341 22.0204 46.3252 25.9234 50.1439 26.9535C51.1662 27.2277 51.6773 27.3706 51.879 27.635C52.0807 27.8994 52.0807 28.7375 52.0807 29.5855M38.3724 42.722C38.3724 42.722 40.3307 43.2782 41.3099 45.2365C41.3099 45.2365 43.4562 40.3407 46.2214 39.3615"
        stroke="#A6DC94"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.1347 27.2129C37.4812 26.3084 36.6234 25.5709 35.6311 25.0605C34.6388 24.55 33.5401 24.281 32.4242 24.2754C28.8992 24.3224 25.6797 27.2325 25.6797 31.0199C25.6797 33.1075 26.2672 34.6154 27.9122 36.2604M52.078 42.2921C52.078 44.889 51.0464 47.3795 49.2101 49.2158C47.3738 51.0521 44.8833 52.0837 42.2864 52.0837C39.6894 52.0837 37.1989 51.0521 35.3626 49.2158C33.5263 47.3795 32.4947 44.889 32.4947 42.2921C32.4947 39.6951 33.5263 37.2046 35.3626 35.3683C37.1989 33.532 39.6894 32.5004 42.2864 32.5004C44.8833 32.5004 47.3738 33.532 49.2101 35.3683C51.0464 37.2046 52.078 39.6951 52.078 42.2921Z"
        stroke="#A6DC94"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const ArifpayCRMIcon = () => (
    <svg
      width="66"
      height="65"
      viewBox="0 0 66 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M48.3818 24.6672H50.4616C51.5004 24.6672 52.4966 25.0798 53.2311 25.8143C53.9656 26.5488 54.3783 27.5451 54.3783 28.5838V36.4172C54.3783 37.4559 53.9656 38.4521 53.2311 39.1867C52.4966 39.9212 51.5004 40.3338 50.4616 40.3338H48.3818C47.9048 44.12 46.0623 47.602 43.2 50.126C40.3378 52.65 36.6527 54.0425 32.8366 54.0422V50.1255C35.9529 50.1255 38.9415 48.8876 41.1451 46.684C43.3486 44.4805 44.5866 41.4918 44.5866 38.3755V26.6255C44.5866 23.5092 43.3486 20.5205 41.1451 18.317C38.9415 16.1134 35.9529 14.8755 32.8366 14.8755C29.7203 14.8755 26.7316 16.1134 24.5281 18.317C22.3245 20.5205 21.0866 23.5092 21.0866 26.6255V40.3338H15.2116C14.1728 40.3338 13.1766 39.9212 12.4421 39.1867C11.7076 38.4521 11.2949 37.4559 11.2949 36.4172V28.5838C11.2949 27.5451 11.7076 26.5488 12.4421 25.8143C13.1766 25.0798 14.1728 24.6672 15.2116 24.6672H17.2913C17.7692 20.8815 19.6121 17.4003 22.4742 14.8768C25.3363 12.3533 29.0209 10.9609 32.8366 10.9609C36.6523 10.9609 40.3369 12.3533 43.199 14.8768C46.0611 17.4003 47.9039 20.8815 48.3818 24.6672ZM15.2116 28.5838V36.4172H17.1699V28.5838H15.2116ZM48.5033 28.5838V36.4172H50.4616V28.5838H48.5033ZM24.5333 39.9128L26.6091 36.5915C28.4754 37.7608 30.6341 38.3793 32.8366 38.3755C35.039 38.3793 37.1977 37.7608 39.0641 36.5915L41.1399 39.9128C38.6515 41.4722 35.7732 42.297 32.8366 42.2922C29.8999 42.297 27.0217 41.4722 24.5333 39.9128Z"
        fill="#A6DC94"
      />
    </svg>
  );

  const TerminalManagementIcon = () => (
    <svg
      width="66"
      height="65"
      viewBox="0 0 66 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M46.8743 23.6882C49.5782 23.6882 51.7702 21.4962 51.7702 18.7923C51.7702 16.0884 49.5782 13.8965 46.8743 13.8965C44.1705 13.8965 41.9785 16.0884 41.9785 18.7923C41.9785 21.4962 44.1705 23.6882 46.8743 23.6882Z"
        stroke="#A6DC94"
        strokeWidth="3"
      />
      <path
        d="M51.278 28.5846V38.8659C51.278 41.9822 50.0401 44.9708 47.8365 47.1744C45.6329 49.3779 42.6443 50.6159 39.528 50.6159H26.7988C23.6825 50.6159 20.6939 49.3779 18.4903 47.1744C16.2868 44.9708 15.0488 41.9822 15.0488 38.8659V26.1367C15.0488 23.0204 16.2868 20.0318 18.4903 17.8282C20.6939 15.6247 23.6825 14.3867 26.7988 14.3867H37.0801"
        stroke="#A6DC94"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M23.9004 38.4637L28.2185 32.7179C28.4829 32.3641 28.8706 32.1225 29.3047 32.0409C29.7388 31.9593 30.1878 32.0436 30.5626 32.2773L34.775 34.9387C35.1643 35.1866 35.6352 35.2719 36.0867 35.1763C36.5382 35.0807 36.9342 34.8119 37.1896 34.4276L41.5254 27.8867"
        stroke="#A6DC94"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const features = [
    {
      icon: RecurringPaymentsIcon,
      title: "Easy Registration & Plan Selection",
      description:
        " Choose from a range of personal insurance plans — health, property, travel, and more.",
    },
    {
      icon: BulkPaymentsIcon,
      title: "Smart Premium Payments",
      description:
        "  Pay premiums directly using Arif Wallet, Telebirr, CBE, or other integrated payment methods.",
    },
    {
      icon: SplitPaymentsIcon,
      title: "Real-Time Notifications",
      description:
        "  Get alerts on policy status, renewal reminders, and claim updates.",
    },
    {
      icon: EventPaymentIntegrationIcon,
      title: "Digital Claims & Tracking",
      description:
        " Submit and track claims digitally, with fast processing and support.",
    },
    // {
    //   icon: ArifpayCRMIcon,
    //   title: "Secure & Transparent",
    //   description:
    //     "  All policies are encrypted and accessible anytime through your profile",
    // },
    // {
    //   icon: TerminalManagementIcon,
    //   title: "Split Parking Cost",
    //   description:
    //     "Share the cost with friends, family, or passengers directly through the app.",
    // },
  ];


    const Newfeatures = [
    {
      icon: RecurringPaymentsIcon,
      title: " Business Coverage",
      description:
        " Insure equipment, inventory, delivery vehicles, and staff health under one platform.",
    },
    {
      icon: BulkPaymentsIcon,
      title: " Partner Insurance Plans",
      description:
        " Offer insurance add-ons to customers for product warranties or service protection.",
    },
    {
      icon: SplitPaymentsIcon,
      title: "Integrated Insights",
      description:
        " View policy statuses and claim histories alongside your financial reports.",
    },
    {
      icon: EventPaymentIntegrationIcon,
      title: "Bulk Enrollment",
      description:
        " Add multiple branches or employees under a single policy — fast and efficiently.",
    },
    // {
    //   icon: ArifpayCRMIcon,
    //   title: "Secure & Transparent",
    //   description:
    //     "  All policies are encrypted and accessible anytime through your profile",
    // },
    // {
    //   icon: TerminalManagementIcon,
    //   title: "Split Parking Cost",
    //   description:
    //     "Share the cost with friends, family, or passengers directly through the app.",
    // },
  ];


  return (
    <div className={styles.paymemnt}>
      <Header />
<section className={styles.paymentGatewaySection}>
  <div className={styles.heroContainer}>
    <div className={styles.heroContent}>
      <h2 style={{textAlign:"center", fontSize:'30px'}}>Arif Insurance</h2>
      <p style={{textAlign:"center", marginTop:"0", fontSize:'24px'}} className={styles.heroTitle}>
        Smart Coverage for Everyday Life and Business
      </p>
      <p className={styles.heroSubtitle}>
        Welcome to the Arif Insurance Platform, a seamless extension of the Arif ecosystem, designed to empower individuals and merchants with secure, accessible, and data-driven insurance services.
      </p>
    </div>

    <div className={styles.heroImageContainer}>
      <img src={paymentGatewayImage} alt="Payment Gateway Illustration" className={styles.heroImage} />
    </div>
  </div>
</section>


       <div className={styles.heroContainer}> {/* Add this wrapper div */}
  <div className={styles.heroContents}>
    <p className={styles.tagline}>For Users</p>
    <h1 className={styles.heroTitle}>
      Protect what matters most.
    </h1>
       <p className={styles.heroSubtitle}>
     From health to personal belongings, our platform helps everyday users access, manage and claim insurance with ease all from their phone.
     
    </p>
    {/* <p className={styles.heroSubtitle}>
      From health to personal belongings, our platform helps everyday users access,
      <span className={styles.breaks}><br/></span> manage
      <span className={styles.breaks}><br/></span>and claim insurance<br/> with ease
      <span className={styles.breaks}><br/></span>all from their phone.
    </p> */}
  </div>
</div>

      <section className={styles.keyFeaturesSection}>
        <div className={styles.header}>
          <h2 className={styles.mainHeading}>Key Features</h2>
          {/* <p className={styles.subHeading}>Everything You Need in One App</p> */}
        </div>
        <div className={styles.featuresGrid}>
          {features.map((feature, index) => (
            <div
              key={index}
              className={`${styles.featureCard} ${
                index === 1 ? styles.featureCardLarge : ""
              }`}
            >
              {/* <div className={styles.iconWrapper}>
                <feature.icon className={styles.featureIcon} />
              </div> */}
              <h3 className={styles.featureTitle}>{feature.title}</h3>
              <p className={styles.featureDescription}>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section>

           <div className={styles.heroContainer}> {/* Add this wrapper div */}
  <div className={styles.heroContent}>
    <p className={styles.tagline}>For Merchant</p>
    <h1 className={styles.heroTitle}>
   Protect your business, staff, and assets
    </h1>
    <p className={styles.heroSubtitle}>
      Arif empowers merchants to manage commercial insurance needs directly from their existing dashboard.
     
    </p>
  </div>
</div>

     
      </section>

      <section className={styles.keyFeaturesSection}>
        <div className={styles.header}>
          <h2 className={styles.mainHeading}>Key Features</h2>
          {/* <p className={styles.subHeading}>Everything You Need in One App</p> */}
        </div>
        <section></section>
        <div className={styles.featuresGrid}>
          {Newfeatures.map((feature, index) => (
            <div
              key={index}
              className={`${styles.featureCard} ${
                index === 1 ? styles.featureCardLarge : ""
              }`}
            >
              {/* <div className={styles.iconWrapper}>
                <feature.icon className={styles.featureIcon} />
              </div> */}
              <h3 className={styles.featureTitle}>{feature.title}</h3>
              <p className={styles.featureDescription}>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>


      

      {/* <section
        style={{
          padding: "20px",
          marginLeft: "20px",
          marginRight: "20px",
          backgroundColor: "white",
          textAlign: "center",
        }}
      >
        <div>
          <h2
            className={styles.heroTitles}
            style={{ textAlign: "center", fontSize: "1.6em" }}
          >
            {" "}
            Tailored Experience for Every Driver
          </h2>
          <p
            className={styles.heroSubtitles}
            style={{ color: "black", textAlign: "center", fontSize: "1.3em" }}
          >
            Whether managing fleets or planning a weekend outing, Arif Parking
            offers accurate spot search
            <br /> multi-vehicle switching, auto check-in/checkout, and
            ride-share expense splitting.
          </p>
        </div>
      </section> */}

      <section className={styles.bottom}>
        <div
          className={styles.bottom}
          style={{
            backgroundColor: "var(--primary-green)",
            color: "#fff",
            padding: "20px 30px",
            borderRadius: "35px",
            margin: "40px 70px 40px 50px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            {/* Text Content */}
            <div
              className={styles.bottom}
              style={{ flex: "1", maxWidth: "550px", marginBottom: "30px" }}
            >
              <h2
                style={{
                  fontSize: "30px",
                  marginBottom: "15px",
                  color: "white",
                }}
              >
Insure Your Business Smarter
              </h2>
              <p style={{ fontSize: "18px" }}>
            Discover how Arif Insurance protects your operations, assets, and workforce — all in one platform. From commercial property and employee health coverage to real-time claims and automated premium payments, Arif gives businesses the protection they need to grow with confidence.
              </p>
            </div>

            {/* Image Side */}
            <div className={styles.bottomImage}
              style={{ flex: "1", display: "flex", justifyContent: "flex-end" }}
            >
              <img
                src={view} // your actual image path
                alt="Payment Terminal"
                style={{
                  width: "100%",
                  // marginLeft:"400px",
                  maxWidth: "450px",
                  height: "350px",
                  objectFit: "cover",
                  borderRadius: "25px",
                  border: "5px solid green",
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CarParking;
